export const PROMOTION_EMAIL_VARIABLES = Object.freeze([
  { key: "employeeName", label: "Participant Name" },
  { key: "firstName", label: "Participant First Name" },
  { key: "bookName", label: "Book Name" },
  { key: "eventName", label: "Event Name" },
  { key: "eventId", label: "Event ID" },
  { key: "eventDate", label: "Event Date" },
  { key: "eventTime", label: "Event Time" },
  { key: "venue", label: "Venue" },
  { key: "locationUrl", label: "Location URL" },
  { key: "description", label: "Event Description" },
  { key: "coordinatorName", label: "Host Name" },
  { key: "takeActionUrl", label: "RSVP Link" },
]);

const keysExcept = (excluded) =>
  PROMOTION_EMAIL_VARIABLES.filter((item) => !excluded.includes(item.key)).map(
    (item) => item.key
  );

const variablesFor = (keys) =>
  Object.freeze(
    keys.map((key) => PROMOTION_EMAIL_VARIABLES.find((item) => item.key === key))
  );

export const CANCELLATION_VARIABLE_KEYS = Object.freeze(
  keysExcept(["takeActionUrl"])
);

export const REMINDER_VARIABLE_KEYS = Object.freeze(
  PROMOTION_EMAIL_VARIABLES.map((item) => item.key)
);

export const INVITE_COPY_VARIABLE_KEYS = Object.freeze(
  keysExcept(["description", "locationUrl", "takeActionUrl"])
);

export const CANCELLATION_VARIABLES = variablesFor(CANCELLATION_VARIABLE_KEYS);
export const REMINDER_VARIABLES = variablesFor(REMINDER_VARIABLE_KEYS);
export const INVITE_COPY_VARIABLES = variablesFor(INVITE_COPY_VARIABLE_KEYS);
